import { AccordionItemSize as FluentAccordionItemSize, AccordionItemMarkerPosition as FluentAccordionItemMarkerPosition } from "@fluentui/web-components";
/**
 * Available size options for the AccordionItem component.
 * @public
 */
export const AccordionItemSizes = { ...FluentAccordionItemSize };
/**
 * Defines the available marker positions for accordion items.
 * Extends the base Fluent accordion marker position options.
 * @public
 */
export const AccordionItemMarkerPositions = {
    ...FluentAccordionItemMarkerPosition
};
//# sourceMappingURL=accordion-item.options.js.map